// @flow

//
// FP
//
import S, { F } from '../../trix-fp-fantasy';

//
// Lodash
//
import merge from 'lodash/merge';

//
// Redux Fantasy
//
import {
    O,
} from '../../redux-fantasy-middleware';

//
// Trix Data
//
import {
    networkError,
} from '../../trix-web-data-commons';

//
// Trix Middleware
//
import {
    validate,
} from '../../trix-web-middleware-commons';

//
// Configuration
//
type Configuration = {
    // actions
    actions: {
        // requestOperation :: data -> action
        requestOperation: (data: any) => any;

        // operationExecuted_Success :: data -> action
        operationExecuted_Success: (data: any) => any;

        // operationExecuted_Failure :: data -> action
        operationExecuted_Failure: (error: any) => any;
    },

    // transitionOnSuccess :: (prevState, nextState, action) -> transitions
    transitionOnSuccess?: (prevState: any, nextState: any, action: any) => any;

    // onSuccess :: Action -> Array Action
    onSuccess?: (a: any) => any[],

    // onFailure :: Action -> Array Action
    onFailure?: (a: any) => any[],
}

const createCustomOperation = (cfg: Configuration): any => 
            (actionPredicate: ((a: any) => Boolean)) => {
    // customTaskFailure :: action -> error -> action
    const customTaskFailure = (action: any) => (error: any) => {
        const actions = [];

        const failureAction = merge({}, cfg.actions.operationExecuted_Failure(error), {
            meta: {
                ...action.meta,
            },
        });
        actions.push(failureAction);

        if (cfg.onFailure) {
            actions.push(...cfg.onFailure(failureAction));
        }

        return actions;
    }

    // customTaskSuccess :: action -> Array action -> Array action
    const customTaskSuccess = (action: any) => (resultActions: any[]) => {
        // enrich resultActions with meta data from initial action
        return resultActions.map(a => merge(
                {},
                a,
                // enrich with initial action's meta
                {
                    meta: {
                        ...action.meta,
                        // ...transition,
                    }
                }
            ));
    }

    const customTask = (action: any) => S.pipe([
        // Action -> Future () Action
        F.resolve,

        // Future () Maybe Action -> Future Never Data
        S.chain (action.payload.execute (cfg)),

        // Timeout if API call takes more than 5 sec
        // TODO: use FP style of composition. Find the math !!!
        // Future Never Data -> Future Error Data
        F.race (F.rejectAfter (60000) (networkError('Request timeout'))),

        // TODO: 
        // Cancel API call on CANCEL action
        // Future Error Data -> Future Error Data
        // F.race (rejectOnAction (a => a.type === 'CANCEL') ('Operation canceled')),
        
        // Future Error Data -> Future Action<Error> Action<Success>
        F.bimap (customTaskFailure (action)) (customTaskSuccess (action)),
    ]) (action);

    return O.takeAllAndFork (actionPredicate) (customTask);
}
export default createCustomOperation;